import zhTW from './zh-TW';
import zhHK from './zh-HK';
import EN from './en';
import id from './id';
import es from './es';
import tr from './tr';
import ptBR from './pt-BR';
import ur from './ur';
import defaultMessages from './zh';
// 去多语言平台更新文案，记得打tag为组件库
import uiLocale from '@k18n/ky-language3/tags/ui/index.json';
export const supportLangs = ['zh', 'en', 'id', 'pt-BR', 'es', 'tr', 'zh-TW', 'ur', 'zh-HK'];
/**
 * 支持的语言列表
 * en 美式英语
 * id 印尼语
 * pt-BR 葡萄牙语
 * es 西班牙语
 * tr 土耳其语
 * zh-TW 繁体中文
 * zh 简体中文
 * ur 乌尔都语
 * zh-HK 繁体中文
 *  */
// @ts-ignore
export const messages = {
    'zh': defaultMessages,
    'en': EN,
    'zh-HK': zhHK,
    'zh-TW': zhTW,
    'id': id,
    'es': es,
    'tr': tr,
    'pt-BR': ptBR,
    'ur': ur,
};
export { uiLocale };
